import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Stack,
  IconButton,
} from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { AlertDialog } from "../common/AlertDailog";
import { useEffect, useState } from "react";
import { useCentralLab } from "../../hooks/useCentralLab";
import { useSnackbar } from "../../hooks/useSnackbar";
import { useAppDispatch } from "../../store";
import { setOpenAddCentralLabModal } from "../../store/slices/studiesSlice";

const CentralLabDetails = (props: any) => {
  const {
    centralLabData,
    selectedStudy,
    setCentralLabData,
    setIsEdit,
    getCentralLabDetail,
  } = props;

  const {
    deleteCentralLab,
    deleteCentralLabData,
    deleteCentralLabError,
    deleteCentralLabIsError,
    deleteCentralLabIsSuccess,
  } = useCentralLab();
  const { showSuccess, handleError } = useSnackbar();
  const [openDeleteCentralLab, setOpenDeleteCentralLab] = useState(false);
  const dispatch = useAppDispatch();

  const handleDeleteCentralLab = () => {
    deleteCentralLab({
      study_id: selectedStudy,
      central_lab_id: centralLabData?.central_lab_id,
    });
  };

  useEffect(() => {
    if (deleteCentralLabIsSuccess) {
      setCentralLabData(null);
      setIsEdit(false);
      showSuccess(deleteCentralLabData?.details, "central-lab-delete-success");
      getCentralLabDetail();
      setOpenDeleteCentralLab(false);
    }
  }, [deleteCentralLabIsSuccess]);

  useEffect(() => {
    if (deleteCentralLabIsError) {
      const error: any = deleteCentralLabError;
      handleError(error);
    }
  }, [deleteCentralLabIsError, deleteCentralLabError]);

  const handleEditCentralLab = () => {
    dispatch(setOpenAddCentralLabModal(true));
    setIsEdit(true);
  };

  return (
    <Box mt={2}>
      <Card className="pageContent">
        <CardContent>
          <Grid container spacing={3} mb={2.5}>
            <Grid item className="maxWidthMinusActionBtns">
              <Typography variant="h6" component="div" className="wordWrap">
                <Stack direction="row" columnGap={1}>
                  <Box className="wordBreakAll">
                    {centralLabData?.central_lab_name}
                  </Box>
                </Stack>
                <Typography variant="body2" color="text.secondary">
                  {centralLabData?.central_lab_id}
                </Typography>
              </Typography>
            </Grid>
            <Grid item>
              <Stack
                direction="row"
                spacing={1}
                className="justifyContentCenter alignItemsCenter"
              >
                <IconButton
                  color="primary"
                  size="small"
                  title="Edit Central Lab"
                  onClick={() => handleEditCentralLab()}
                  aria-label="Click to edit Central Lab details"
                >
                  <EditIcon fontSize="small" />
                </IconButton>

                <IconButton
                  color="primary"
                  size="small"
                  title="Delete Central Lab"
                  onClick={() => setOpenDeleteCentralLab(true)}
                  aria-label="Click to delete Central Lab"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Stack>
            </Grid>
          </Grid>

          <Grid container spacing={2} mb={1.5}>
            <Grid item sm={12} md={12}>
              <Typography variant="caption" display="block">
                Address
              </Typography>
              <Typography variant="body1" gutterBottom>
                {centralLabData?.street_address},
                {centralLabData?.unit_number &&
                  `${centralLabData?.unit_number},`}{" "}
                {centralLabData?.city}, {centralLabData?.state},{" "}
                {centralLabData?.postal_code}, {centralLabData?.country}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} mb={2}>
            <Grid item sm={12} md={4}>
              <Typography variant="caption">Contact Name</Typography>
              <Typography variant="body1" className="wordWrap">
                {centralLabData?.contact_name}
              </Typography>
            </Grid>
            <Grid item sm={12} md={4}>
              <Typography variant="caption">Contact Email</Typography>
              <Typography variant="body1" className="wordWrap">
                {centralLabData?.contact_email}
              </Typography>
            </Grid>
            <Grid item sm={12} md={4}>
              <Typography variant="caption">Contact Phone Number</Typography>
              <Typography variant="body1">
                {centralLabData?.contact_phone_number}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <AlertDialog
        open={openDeleteCentralLab}
        title="Delete Central Lab"
        description={`Are you sure you want to delete the central lab <strong>${centralLabData?.central_lab_name}</strong>?`}
        handleClose={() => setOpenDeleteCentralLab(false)}
        handleConfirm={handleDeleteCentralLab}
        confirmBtn="Yes"
        cancelBtn="No"
        maxWidth="xs"
      />
    </Box>
  );
};

export default CentralLabDetails;
